import React from "react";
import { arrayOf, bool, number, shape, string } from "prop-types";
import { Field } from "redux-form";
import { File, Input, Venues, Wysiwyg } from "Components/Form";
import { maxLength, maxLengthSub1k, required } from "modules/validation";
import HotelGroupFilters from "../../../pages/admin/Analytics/HotelGroupFilters";

const v = {
  title: [required(), maxLength(100)],
  content: [required(), maxLengthSub1k(6000)],
};

export default class ArticleFields extends React.Component {
  static propTypes = {
    formId: string.isRequired,
    venuePermissionToCheck: string,
    isRolePlatformAdmin: bool,
    venueOptions: arrayOf(
      shape({
        id: number.isRequired,
        name: string.isRequired,
      })
    ),
  };

  render() {
    return (
      <React.Fragment>
        <Field
          name="title"
          label="Title"
          component={Input}
          validate={v.title}
        />
        <HotelGroupFilters
          change={this.props.change}
          values={this.props.values}
          noSearch={true}
          personalVenues={this.props.offer ? this.props.offer.venues : []}
          alwaysRevealSpecificOnStart={true}
          alwaysRevealGroupsOnStart={true}
          noTimeout={true}
          data={this.props.offer}
          isNonAnalytics={true}
          venuePermissionToCheck={this.props.venuePermissionToCheck}
       />
        {this.props.isRolePlatformAdmin ?   <Field name="slug" label="Slug" component={Input}  />: null}
        <Field
          name="content"
          label="Content"
          component={Wysiwyg}
          validate={v.content}
        />
        <File
          type="image"
          path={`${window.API}/cms/images`}
          objectName="image"
          idName="image_id"
          formId={this.props.formId}
        />
        <File
          label="Attachments"
          type="document"
          array
          path={`${window.API}/cms/files`}
          readFrom="files"
          formId={this.props.formId}
        />
      </React.Fragment>
    );
  }
}
